import { Country } from './country';

export class Department {
    constructor(
        public id?: string,
        public code?: string,
        public name?: string,
        public country?: Country
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/core/entities/department.ts